import React from 'react';
import { KPI } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPISet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const checkRPOFilterModel = {
            items: [
                {
                    'field': 'isRpo',
                    'operator': '=',
                    'value': 'false'
                },
                {
                    'field': 'isBlackList',
                    'operator': '=',
                    'value': 'false'
                }
            ]
        }


    const concreteFilter = { items:[...(checkRPOFilterModel?.items ?? []), ...(filterModel?.items ?? [])]}
    const now = new Date().toISOString();

    return (drawable &&
        <Box className="mtska-kpi-set">

            <KPI
                title="Lead totali"
                icon="faPerson"
                className="highlighted"
                dataProviderName={'statisticsviews/item/count/audiences/audienceLead'}
            />
            <KPI
                title="Lead lavorabili"
                icon="faBullhorn"
                dataProviderName={'statisticsviews/item/count/audiences/audienceLead'}
                filters={checkRPOFilterModel}
            />
            <KPI
                title="Leads filtate"
                icon="faPersonCircleCheck"
                dataProviderName={'statisticsviews/item/count/audiences/audienceLead'}
                filters={concreteFilter}
            />
            <KPI
                title="Lead in campagna"
                icon="faBullhorn"
                dataProviderName={'statisticsviews/item/count/audiences/audienceLead'}
                filters={{
                    items: [
                        {
                            'field': 'lastCampaignEnd_at',
                            'operator': '>',
                            'value': now
                        }
                    ]
                }}
            />

        </Box>
    )
}

export default KPISet;